import { Box, Grid, GridItem, GridItemProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

export const TwoColumnsLayout = ({
  children,
  rightGridItemProps,
}: {
  children: ReactNode;
  rightGridItemProps?: GridItemProps;
}) => {
  return (
    <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}>
      <GridItem>
        <Box
          display={{ base: 'none', md: 'block' }}
          height={{ base: 'auto', md: innerHeight }}
          backgroundImage="url(/home.png)"
          backgroundPosition="center center"
          backgroundSize="cover"
        />
      </GridItem>
      <GridItem
        bg="linear-gradient(to bottom, white 0%, var(--chakra-colors-purple-50) 100%)"
        {...rightGridItemProps}
      >
        {children}
      </GridItem>
    </Grid>
  );
};
